import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer 
      id="kontakt" 
      style={{
        background: "url('images/footer.png') center/cover no-repeat",
        color: '#fff',
        padding: '80px 20px',
        position: 'relative'
      }}
    >
      {/* Překrytí pro lepší čitelnost textu */}
      <div style={{ 
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, 
        backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1 
      }}></div>

      <motion.div 
        style={{ maxWidth: '1200px', margin: 'auto', position: 'relative', zIndex: 2 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        
        {/* Sekce sociálních sítí */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: '30px' }}>
          <h3 style={{ fontStyle: 'italic', fontSize: '1.6rem', fontFamily: "'Playfair Display', serif" }}>Sleduj mě:</h3>
          <div style={{ display: 'flex', gap: '25px', fontSize: '1.4rem' }}>
            <motion.a 
              href="https://instagram.com" 
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2, color: '#d1b892' }} 
              style={{ color: '#fff', textDecoration: 'none', transition: 'color 0.3s' }}
            >
              Instagram
            </motion.a>
            <motion.a 
              href="https://facebook.com" 
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2, color: '#d1b892' }} 
              style={{ color: '#fff', textDecoration: 'none', transition: 'color 0.3s' }}
            >
              Facebook
            </motion.a>
          </div>
        </div>

        {/* Horizontální linka */}
        <motion.div 
          initial={{ width: 0 }}
          whileInView={{ width: '100%' }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          style={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.2)', marginBottom: '40px' }}
        ></motion.div>

        {/* Hlavní obsah patičky */}
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '40px' }}>
          
          {/* Logo */}
          <motion.div whileHover={{ rotate: [0, -2, 2, 0] }}>
            <img src="images/logo.png" alt="Logo" style={{ height: '100px', width: 'auto' }} />
          </motion.div>

          {/* Kontaktní údaje */}
          <div style={{ lineHeight: '1.8' }}>
            <h4 style={{ marginBottom: '15px', fontWeight: 'bold', color: '#d1b892', letterSpacing: '1px' }}>KONTAKT</h4>
            <p>Email: <a href="mailto:kolarikva@seznam.cz" style={{ color: '#fff', textDecoration: 'none' }}>kolarikva@seznam.cz</a></p>
            <p>Telefon: +420 607 935 018</p>
            <p>Adresa: Příční 382/5, Svatobořice 696 04</p>
          </div>

          {/* Rychlá navigace */}
          <div>
            <h4 style={{ marginBottom: '15px', fontWeight: 'bold', color: '#d1b892', letterSpacing: '1px' }}>NAVIGACE</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {['Galerie', 'E-shop', 'Kontakt'].map((item) => (
                <li key={item} style={{ marginBottom: '8px' }}>
                  <Link 
                    to={item === 'E-shop' ? '/eshop' : `/${item.toLowerCase()}`}
                    style={{ color: '#fff', textDecoration: 'none', display: 'inline-block' }}
                  >
                    <motion.span whileHover={{ x: 5, color: '#d1b892' }}>{item}</motion.span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Právní sekce a Copyright */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '60px', 
          fontSize: '13px', 
          color: '#aaa', 
          borderTop: '1px solid rgba(255,255,255,0.1)', 
          paddingTop: '30px' 
        }}>
          <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '25px', flexWrap: 'wrap' }}>
            <Link to="/obchodni-podminky" style={{ color: '#aaa', textDecoration: 'none' }}>
              <motion.span whileHover={{ color: '#fff' }}>Obchodní podmínky</motion.span>
            </Link>
            <Link to="/gdpr" style={{ color: '#aaa', textDecoration: 'none' }}>
              <motion.span whileHover={{ color: '#fff' }}>GDPR</motion.span>
            </Link>
            <Link to="/cookies" style={{ color: '#aaa', textDecoration: 'none' }}>
              <motion.span whileHover={{ color: '#fff' }}>Cookies</motion.span>
            </Link>
          </div>
          <p style={{ opacity: 0.7 }}>
            &copy; {new Date().getFullYear()} Václav Kolařík • Umělecké řezbářství • Všechna práva vyhrazena
          </p>
        </div>

      </motion.div>
    </footer>
  );
};

export default Footer;